module.exports = __webpack_public_path__ + "static/media/IMG_2419.0d2183f4.JPG";